import { render } from "./BusinessAccount.vue?vue&type=template&id=2c5d18a6&scoped=true"
import script from "./BusinessAccount.vue?vue&type=script&lang=js"
export * from "./BusinessAccount.vue?vue&type=script&lang=js"

import "./BusinessAccount.vue?vue&type=style&index=0&id=2c5d18a6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c5d18a6"]])

export default __exports__